import ResponsivePagination from "react-responsive-pagination";
import { normalizePaginationLimit } from "../constants/pagination";

const Paginator = ({ total, currentPage, limit, onPageChange, maxWidth }) => {
  const safeLimit = normalizePaginationLimit(limit);
  const safeTotal = Math.max(0, Number(total) || 0);
  const safeCurrentPage = Math.max(1, Number(currentPage) || 1);
  const pageMax = Math.max(1, Math.ceil(safeTotal / safeLimit));

  return (
    <div className="flex-center" style={{ maxWidth }}>
      <ul className="pagination">
        <li className={`page-item ${safeCurrentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(1)}
            disabled={safeCurrentPage === 1}
          >
            <div className="flex-center">
              <i className="fa fa-angle-left fa" style={{ width: "4px" }} />
              <i className="fa fa-angle-left fa" style={{ width: "4px" }} />
            </div>
          </button>
        </li>
      </ul>
      <div style={{ maxWidth: maxWidth - 100 }}>
        <ResponsivePagination
          current={Math.min(safeCurrentPage, pageMax)}
          total={pageMax}
          onPageChange={onPageChange}
          previousLabel={
            <div className="flex-center">
              <i className="fa fa-angle-left fa" />
            </div>
          }
          nextLabel={
            <div className="flex-center">
              <i className="fa fa-angle-right fa" />
            </div>
          }
        />
      </div>
      <ul className="pagination">
        <li
          className={`page-item ${safeCurrentPage === pageMax ? "disabled" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => onPageChange(pageMax)}
            disabled={safeCurrentPage === pageMax}
          >
            <div className="flex-center">
              <i className="fa fa-angle-right fa" style={{ width: "4px" }} />
              <i className="fa fa-angle-right fa" style={{ width: "4px" }} />
            </div>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Paginator;
